/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */

import React, { PureComponent } from 'react';

import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

class UnStyledLearnMoreLink extends PureComponent {
  static defaultProps = {
    linkText: 'LearnMore',
    label: null,
    ariaLabel: null,
    text: '',
    href: '#!',
    linkType: 'helpPopup',
    onLinkClick: undefined,
    noLink: false,
  };

  render() {
    const {
      ariaLabel, label, text, linkText, topic, href, linkType, classes, onLinkClick, noLink,
    } = this.props;

    const helpTopic = `help:${topic}`;
    const aria = ariaLabel || `${label || text} ${linkText}`;
    const learnMoreLink = {
      helpPopup: (<a className="HelpTopic clickable" query={helpTopic} href={href} aria-label={aria} role="button">{linkText}</a>),
      fwdLink: (<a className="Fwlink clickable" href={`http://go.microsoft.com/fwlink?LinkId=${topic}`} target="_apexPlatformHelp" aria-label={aria} role="button">{linkText}</a>),
      delegate: (<a className="DelegateLink clickable" href={href} aria-label={aria} role="button" onClick={onLinkClick}>{linkText}</a>),
      directLink: (<a className="directLink clickable" href={href} aria-label={aria} target="_blank" rel="noreferrer">{linkText}</a>),
    };

    return (<span className={classes.link}>{text} {!noLink && learnMoreLink[linkType]}</span>);
  }
}

UnStyledLearnMoreLink.propTypes = {
  text: PropTypes.string,
  topic: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  href: PropTypes.string,
  linkType: PropTypes.string,
  classes: PropTypes.shape({
    link: PropTypes.string.isRequired,
  }).isRequired,
  onLinkClick: PropTypes.func,
  noLink: PropTypes.bool,
};

const { internalLinkStyle, underlineLinkStyle } = ComponentSettings;
const getUnderlineLinkStyle = (palette, isGreyBackground) => underlineLinkStyle({ palette, elementLocator: 'a.HelpTopic, a.Fwlink, a.DelegateLink', isGreyBackground });
const getInternalLinkStyle = (palette, isGreyBackground) => internalLinkStyle({ palette, elementLocator: 'a.HelpTopic, a.Fwlink, a.DelegateLink', isGreyBackground });
const GreyBackgroundUnderlineLink = withDefaultStyles(
  UnStyledLearnMoreLink,
  (_, { palette = {} } = {}) => ({ link: getUnderlineLinkStyle(palette, true) })
);
const NonGreyBackgroundUnderlineLink = withDefaultStyles(
  UnStyledLearnMoreLink,
  (_, { palette = {} } = {}) => ({ link: getUnderlineLinkStyle(palette, false) })
);
const GreyBackgroundInternalLink = withDefaultStyles(
  UnStyledLearnMoreLink,
  (_, { palette = {} } = {}) => ({ link: getInternalLinkStyle(palette, true) })
);
const NonGreyBackgroundInternalLink = withDefaultStyles(
  UnStyledLearnMoreLink,
  (_, { palette = {} } = {}) => ({ link: getInternalLinkStyle(palette, false) })
);

export const LearnMoreLink = ({
  isUnderlineLink,
  isGreyBackground,
  ...props
}) => {
  let StyledLearnMoreLink = null;
  if (isUnderlineLink) {
    if (isGreyBackground) {
      StyledLearnMoreLink = GreyBackgroundUnderlineLink;
    } else {
      StyledLearnMoreLink = NonGreyBackgroundUnderlineLink;
    }
  } else if (isGreyBackground) {
    StyledLearnMoreLink = GreyBackgroundInternalLink;
  } else {
    StyledLearnMoreLink = NonGreyBackgroundInternalLink;
  }

  return <StyledLearnMoreLink {...props} />;
};

LearnMoreLink.defaultProps = {
  isUnderlineLink: true,
  isGreyBackground: false,
};

LearnMoreLink.propTypes = {
  isUnderlineLink: PropTypes.bool,
  isGreyBackground: PropTypes.bool,
};
